import { render, staticRenderFns } from "./cargoType.vue?vue&type=template&id=707633a1&"
import script from "./cargoType.vue?vue&type=script&lang=js&"
export * from "./cargoType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('707633a1')) {
      api.createRecord('707633a1', component.options)
    } else {
      api.reload('707633a1', component.options)
    }
    module.hot.accept("./cargoType.vue?vue&type=template&id=707633a1&", function () {
      api.rerender('707633a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/cargoType.vue"
export default component.exports